/**
 * @description      :
 * @author           :
 * @group            :
 * @created          : 31/08/2021 - 16:44:46
 *
 * MODIFICATION LOG
 * - Version         : 1.0.0
 * - Date            : 31/08/2021
 * - Author          :
 * - Modification    :
 * */
import styled from 'styled-components';
import { DatePicker } from 'antd';
import colors from '../../styles/colors';

const { RangePicker } = DatePicker;

export const RangePickerCustom = styled(RangePicker)`
  background: ${colors.gbGrey};
  border: none;
  box-shadow: none;
  .ant-picker-input > input {
    color: ${colors.greyText} !important;
  }
  .ant-picker-cell-in-view.ant-picker-cell-in-range {
    color: purple !important;
  }
  .ant-picker-suffix {
    color: ${colors.verde};
  }
`;
